const { USE_OLD_STORAGE_SETTINGS } = require("../../constants/cookies");

const { getAbTestVariantNew, isInTest } = require("../new-ab-tests/new-ab-tests-service");

const { doesCountryRequireStrictCookiePolicy } = require("../../server/services/aws-service/browser-service");

const { GERMAN_LOCALE_ID } = require("../../constants/localization.js");
const {
  SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST,
  DRIFT_PRICING_CHATBOT_CONTACT_SALES_AB_TEST,
  WORK_EMAIL_SUGGESTION_AB_TEST,
  EXIT_POP_UP_SURVEY_AB_TEST,
  LEARN_MORE_AND_SIGNUP_BUTTON,
  LEARN_MORE_TO_PRODUCT_BUTTON,
  REVIVE_EXIT_POPUP_AB_TEST,
  PERFORMANCE_STATIC_PAGE_AB_TEST,
  BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES,
  TEMPLATES_IN_HEADER_AB_TEST,
  MOBILE_SIGNUP_REMOVE_EMAIL_FIELD_AB_TEST,
  GERMAN_TRY_FOR_FREE_TEST,
  DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST,
  MOBILE_TEMPLATE_CENTER_IN_MENU,
  CONSULT_WITH_US_MENU_AB_TEST
} = require("../../constants/new-ab-tests");

const { EMBEDDED_SECONDARY_BUTTON_AB_TEST } = require("../../constants/signup-secondary-button-ab-tests");

const shouldGetSkipSignUpStepInPricingAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return getAbTestVariantNew(abTests, SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, sendBigBrainEvent) === "new_with_skip";
};

const shouldSeeWorkEmailSuggestionAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, WORK_EMAIL_SUGGESTION_AB_TEST, sendBigBrainEvent) === "new_with_work_email_suggestion"
  );
};

const shouldGetPricingChatbotContactSalesAbTest = (abTests = [], sendBigBrainEvent) => {
  return (
    getAbTestVariantNew(abTests, DRIFT_PRICING_CHATBOT_CONTACT_SALES_AB_TEST, sendBigBrainEvent) === "new_with_chat"
  );
};

const shouldSeeExitPopupSurveyAbTest = (abTests = [], sendBigBrainEvent) => {
  return getAbTestVariantNew(abTests, EXIT_POP_UP_SURVEY_AB_TEST, sendBigBrainEvent) === "new_with_survey";
};

const shouldSeeLearnMoreAndSignupButton = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, LEARN_MORE_AND_SIGNUP_BUTTON.test_name, sendBigBrainEvent) ===
    LEARN_MORE_AND_SIGNUP_BUTTON.new_variation_name
  );
};

const shouldSeeLearnMoreToProductButton = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, LEARN_MORE_TO_PRODUCT_BUTTON.test_name, sendBigBrainEvent) ===
    LEARN_MORE_TO_PRODUCT_BUTTON.new_variation_name
  );
};

const shouldSeeTryItOutEmbeddedButton = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, EMBEDDED_SECONDARY_BUTTON_AB_TEST.test_name, sendBigBrainEvent) ===
    EMBEDDED_SECONDARY_BUTTON_AB_TEST.new_variation_name
  );
};

const shouldSeeReviveExitPopupAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, REVIVE_EXIT_POPUP_AB_TEST.test_name, sendBigBrainEvent) ===
    REVIVE_EXIT_POPUP_AB_TEST.new_variation_name
  );
};

const shouldSeeStaticPagePerformanceAbTest = (
  abTests = [],
  cloudfrontViewerCountry = null,
  sendBigBrainEvent = false
) => {
  if (doesCountryRequireStrictCookiePolicy(cloudfrontViewerCountry)) return false;
  return (
    getAbTestVariantNew(abTests, PERFORMANCE_STATIC_PAGE_AB_TEST.test_name, sendBigBrainEvent) ===
    PERFORMANCE_STATIC_PAGE_AB_TEST.new_variation_name
  );
};

const shouldShowBiggerStorageInPricingFeatures = (abTests = [], cookies = {}, sendBigBrainEvent = false) => {
  if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
    return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
  }
  return (
    getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) ===
    BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name
  );
};

const shouldSeeTemplatesInHeader = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, TEMPLATES_IN_HEADER_AB_TEST.test_name, sendBigBrainEvent) ===
    TEMPLATES_IN_HEADER_AB_TEST.new_variation_name
  );
};

const shouldSeeMobileSignupWithoutEmailField = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, MOBILE_SIGNUP_REMOVE_EMAIL_FIELD_AB_TEST.test_name, sendBigBrainEvent) ===
    MOBILE_SIGNUP_REMOVE_EMAIL_FIELD_AB_TEST.new_variation_name
  );
};

const shouldSeeGermanTryForFreeAbTest = (abTests = [], localeId, sendBigBrainEvent = false) => {
  if (localeId !== GERMAN_LOCALE_ID) return false;

  return (
    getAbTestVariantNew(abTests, GERMAN_TRY_FOR_FREE_TEST.test_name, sendBigBrainEvent) ===
    GERMAN_TRY_FOR_FREE_TEST.new_variation_name
  );
};

const shouldSeeDesktopWithEnterpriseMenuAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.test_name, sendBigBrainEvent) ===
    DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.new_variation_name
  );
};

const shouldSeeMobileTemplateCenterInMenuAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, MOBILE_TEMPLATE_CENTER_IN_MENU.test_name, sendBigBrainEvent) ===
    MOBILE_TEMPLATE_CENTER_IN_MENU.new_variation_name
  );
};

const shouldSeeConsultWithUsAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, CONSULT_WITH_US_MENU_AB_TEST.test_name, sendBigBrainEvent) ===
    CONSULT_WITH_US_MENU_AB_TEST.new_variation_name
  );
};

module.exports = {
  shouldGetSkipSignUpStepInPricingAbTest,
  shouldSeeWorkEmailSuggestionAbTest,
  shouldGetPricingChatbotContactSalesAbTest,
  shouldSeeExitPopupSurveyAbTest,
  shouldSeeLearnMoreAndSignupButton,
  shouldSeeLearnMoreToProductButton,
  shouldSeeTryItOutEmbeddedButton,
  shouldSeeReviveExitPopupAbTest,
  shouldSeeStaticPagePerformanceAbTest,
  shouldShowBiggerStorageInPricingFeatures,
  shouldSeeTemplatesInHeader,
  shouldSeeMobileSignupWithoutEmailField,
  shouldSeeGermanTryForFreeAbTest,
  shouldSeeDesktopWithEnterpriseMenuAbTest,
  shouldSeeMobileTemplateCenterInMenuAbTest,
  shouldSeeConsultWithUsAbTest
};
